export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/lvyuebaohan-354d20fcec01bce758565f4cbd710dba.png";